import { mdiMagnify, mdiPound } from '@mdi/js';
import Icon from '@mdi/react';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import useInput from '@/hooks/inputHook';
import { useAuth } from '@/providers/AuthProvider';
import eventAdd from '@/lib/eventAdd';

const SearchForm = (): JSX.Element => {
  const router = useRouter();
  const [type, setType] = useState('search');
  const { uid, auth } = useAuth();
  const { value: squery, setValue: setSquery, bind: bindSquery } = useInput('');

  useEffect(() => {
    if (router.query.query) {
      if (Array.isArray(router.query.query)) {
        setSquery(router.query.query[0].replace(/-/g, ' '));
      } else {
        setSquery(router.query.query.replace(/-/g, ' '));
      }
    } else {
      setSquery('');
    }
  }, [router.query.query, setSquery]);

  useEffect(() => {
    if (router.pathname === '/hashtag/[[...query]]') {
      setType('hashtag');
    } else {
      setType('search');
    }
  }, [router.pathname]);

  const handleSubmit = async (event: React.SyntheticEvent) => {
    event.preventDefault();
    if (uid && auth?.email) {
      await eventAdd({
        uid,
        eventType: 'SEARCH:SUBMIT',
        eventSource: 'SEARCH',
        eventSourceId: uid,
        meta: { query: squery },
        email: auth.email,
        platform: 'web',
      });
    }
    router.push(`/search/${squery}`);
  };

  return (
    <form
      noValidate
      action="/search"
      role="search"
      className={`search-form${type === 'hashtag' ? ' is-small' : ''}`}
      onSubmit={handleSubmit}>
      <div className="container is-narrow">
        {type === 'search' && (
          <h1 className="has-text-white is-size-3">
            Looking for
            <br />
            something specific?
          </h1>
        )}
        <div className="field has-addons">
          <div className="control is-expanded has-icons-left input-control">
            <input
              type="search"
              autoComplete="off"
              className="input is-medium"
              placeholder="Search here"
              {...bindSquery}
            />
            <span className="icon is-left">
              <Icon
                path={type === 'hashtag' ? mdiPound : mdiMagnify}
                size={1}
              />
            </span>
          </div>
          <div className="control">
            <button type="submit" className="button is-medium is-primary">
              Search
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};
export default SearchForm;
